<template>
  <div>
    <Head title="Create Organization" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/agencies">Agencies</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Agency</li>
      </ol>
    </nav>
    <h1>
      Create Agency
    </h1>
    <div class="content-box overflow-hidden">
      <form @submit.prevent="store">
        <AgencyForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Agency</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import AgencyForm from './components/AgencyForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    AgencyForm,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        phone: null,
        address_1: null,
        address_2: null,
        city: null,
        region: null,
        country: null,
        postal_code: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/agencies')
    },
  },
}
</script>
